import { PageRoots, UrlParams } from '@provision/portal-routes';
import { Route } from 'react-router-dom';
import { RootSelectedView } from 'src/pages/CustomViews/custom-views-selected-view';
import { Search } from 'src/pages/Search';
import { getRoutePath } from 'src/routes/utils';

export const SearchRoutes = ({ relative = false }: { relative?: boolean }) => (
  <Route path={getRoutePath(PageRoots.search, relative)} element={<Search />}>
    <Route path={UrlParams.entityName} element={<RootSelectedView />} />
  </Route>
);
